import { useContext } from 'react';
import { GrowthOpsContext } from '../context/GrowthOpsContextObject';

export function useGrowthOps() {
  const context = useContext(GrowthOpsContext);
  if (context === undefined) {
    throw new Error('useGrowthOps must be used within a GrowthOpsProvider');
  }
  return context;
}
